import React from 'react';
import { createStyleSheet, useStyleSheet, Text, View } from '@gopeerproject/ui-kit';
export const CustomTooltip = ({ active, payload, label, valuePrefix = '', roundTo = 0 }) => {
    var _a;
    const styles = useStyleSheet(getStyles);
    return active && payload && payload[0] ? (React.createElement(View, { style: styles.container },
        React.createElement(Text, { type: 'headline', size: 'md' },
            valuePrefix, (_a = payload[0].value) === null || _a === void 0 ? void 0 :
            _a.toFixed(roundTo)),
        React.createElement(Text, { type: 'body', weight: 'regular', size: 'sm' }, label !== null && label !== void 0 ? label : payload[0].name))) : (React.createElement(React.Fragment, null));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        backgroundColor: color.bg.v3,
        borderRadius: size.C,
        marginLeft: size.F,
        padding: size.C,
        shadowOffset: {
            width: 0,
            height: size.C
        },
        shadowRadius: 42,
        shadowColor: 'rgba(28, 29, 40, 0.1)'
    }
}));
//# sourceMappingURL=CustomTooltip.js.map